import React, { useState } from 'react';
import { Users, UserPlus } from 'lucide-react';
import TeamsList from './TeamsList';
import TeamMembersList from './TeamMembersList';
import '../../styles/designSystem.css';
import './teams.scss';

const TeamsManagement = () => {
  const [activeTab, setActiveTab] = useState('members');

  return (
    <div className="settings-content-wrapper">
      {/* Sub-tabs for Teams vs Members */}
      <div className="ds-flex ds-gap-2" style={{ marginBottom: 'var(--spacing-6)', borderBottom: '2px solid var(--border-light)' }}>
        <button
          className={`ds-btn ${activeTab === 'members' ? 'ds-btn-primary' : 'ds-btn-ghost'}`}
          onClick={() => setActiveTab('members')}
          style={{
            borderRadius: 'var(--radius-base) var(--radius-base) 0 0',
            borderBottom: activeTab === 'members' ? '2px solid var(--color-primary)' : 'none',
            marginBottom: '-2px'
          }}
        >
          <UserPlus size={18} />
          Team Members
        </button>
        <button
          className={`ds-btn ${activeTab === 'teams' ? 'ds-btn-primary' : 'ds-btn-ghost'}`}
          onClick={() => setActiveTab('teams')}
          style={{
            borderRadius: 'var(--radius-base) var(--radius-base) 0 0',
            borderBottom: activeTab === 'teams' ? '2px solid var(--color-primary)' : 'none',
            marginBottom: '-2px'
          }}
        >
          <Users size={18} />
          Teams
        </button>
      </div>

      <div>
        {activeTab === 'members' ? <TeamMembersList /> : <TeamsList />}
      </div>
    </div>
  );
};

export default TeamsManagement;